module.exports = {"TXTCLI_Select_All":{"id":"TXTCLI_Select_All","defaultMessage":"Alles auswählen","track":"Select All"}}